import { combineReducers } from 'redux';
import User from './user/reducer';
import Payments from './payments/reducer';
import LayoutSettings from './layout/reducer';
import Xoxoday from './xoxoday/reducer';
import Workspace from './workspace/reducer';

export default combineReducers({ User, Payments, LayoutSettings, Xoxoday, Workspace });
